import { createSelector } from 'reselect';

export const authScopesSelector = state => state.authScopes;

export const authScopesDataSelector = createSelector(authScopesSelector, item => item.data);

export const authScopesDataByScopeSelector = scope =>
  createSelector(authScopesDataSelector, item => item.find(item2 => item2.scope === scope));
